import styled from 'styled-components';

export const SVGBackground = styled.div<{ $src: string }>`
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-image: url(${({ $src }) => $src});
  background-size: cover;
  background-position: center;
`;

export const UnBrandedBackground = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
